export default class Material {
  readonly id: number
  readonly fileName: string
  readonly link: string

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.fileName = data.filename
    this.link = data.link
  }
}
